import { trackEvent } from "@adsk/acc-issues-core/utils/analytics/trackEvent";

export type geoActionParams = {
  origin?: string;
  method?: string;
  action?: string;
};

export const GEO_EVENTS = {
  COORDINATES: "coordinates",
  OPEN_MAP_VIEW: "map_view.open",
};

export const GEO_ACTIONS = {
  SET: "set",
  EDIT: "edit",
  REMOVE: "remove",
};

export const GEO_SET_METHODS = {
  PLACED_WITH_MAP: "Place location on map",
  TEXT_INPUT: "Text Input",
};

export const GEO_OPEN_MAP_SOURCES = {
  DETAILS: "issue details",
  MAP_BUTTON: "map button",
};

export const trackGeoAction = (
  actionName: string,
  parameters: geoActionParams
) => {
  trackEvent({
    name: `issue.gps.${actionName}`,
    parameters: parameters,
  });
};
